import Vue from 'vue';

// local state
const getDefaultState = () => {
    return {
        project: {
            id: null,
            name: '',
            number: '',
            street: '',
            post_code: '',
            city: '',
            country: '276',
            description: '',
            status: 0,
            customer: {
                first_name: '',
                last_name: '',
                phone: '',
                mobile: '',
                email: '',
            },
            offer: {
                vat: '',
                freight_position:''
            },
            configuration: {
                id: null,
                service_id: null,
                description: '',
                editor: '',
                source: '',
                status: 1,
                version: null,
                formula_version: null,
                note: null,

            },
            contacts: [{
                id: null,
                type: 1,
                form_of_address: null,
                first_name: '',
                last_name: '',
                phone: '',
                mobile: '',
                email: '',
                company_name: null,
                company_street: null,
                company_post_code: null,
                company_city: null,
                company_country: null,
                company_email: null,
                company_website: null,
            }]
        }
    }
};

const state = getDefaultState()

const getters = {

};

const mutations = {
    updateProject(state, value) {
        state.value = value
    },
    resetState(state) {
        Object.assign(state, getDefaultState())
    }
};

const actions = {
    resetState({ commit }) {
        commit('resetState')
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
